const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/work-integrations/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import i18n from '@/lib/translations/i18n';
const integrationsSchema = z.object({
  integration: z.custom<WorkIntegration_Keys>().optional(),
  oauthCredentialsId: z.number().optional(),
  integrationId: z.number().optional(),
  createInstance: z.string().optional(),
  instanceId: z.string().optional(),
  instanceUrl: z.string().optional(),
  loopId: z.number().optional()
});
export const Route = createFileRoute('/(app)/org/$org/settings/work-integrations/')({
  validateSearch: zodValidator(integrationsSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: (): LoaderData => ({
    crumb: i18n.t($ => $.common.settings['work-integrations'].integrations)
  }),
  staticData: {
    topNav: {
      title: i18n.t($ => $.common.settings['work-integrations'].integrations)
    }
  }
});